/*
  Similar pattern to StyledHeader
*/

import styled from "styled-components";

export const StyledFooter = styled.footer`
  width: 100%;
  box-sizing: border-box;
  padding: var(--lib-default-spacing);

  display: grid;
  align-items: center;
  gap: calc(var(--lib-default-spacing) / 2);
`;

export const StyledLandingFooter = styled(StyledFooter)`
  justify-content: center;
`;

export const StyledDetailFooter = styled(StyledFooter)`
  display: block;
  padding: 0;
  justify-content: space-between;
`;

export const StyledFooterContent = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  align-items: center;
  justify-content: center;
  gap: calc(var(--lib-default-spacing) / 2);

  margin: 0 auto;
  padding: calc(var(--lib-default-spacing) / 2) var(--lib-default-spacing);
  border-radius: 0.25rem;
  background-color: rgba(255, 255, 255, 0.92);

  &.details-footer-content {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--lib-default-spacing);
    margin: 0;
    padding: var(--lib-default-spacing);

    @media screen and (max-width: 30rem) {
      flex-direction: column;
      align-items: flex-start;
      gap: calc(var(--lib-default-spacing) / 2);
    }
  }
`;

export const StyledFeedbackLink = styled.a`
  color: #1a19bc;
  font-size: 1.05rem;
  font-weight: 500;
  line-height: 1.2;
  text-decoration: underline;
  white-space: nowrap;
  flex: 0 0 auto;

  @media screen and (max-width: 30rem) {
    align-self: flex-start;
  }
`;

